import { useEffect, useState } from 'react'

type Countdown = {
  minutes: string
  seconds: string
  formatted: string
  isExpired: boolean
}

export function useCountdown(initialSeconds: number): Countdown {
  const [remaining, setRemaining] = useState<number>(initialSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((current) => {
        if (current <= 1) {
          window.clearInterval(id)
          return 0
        }
        return current - 1
      })
    }, 1000)

    return () => window.clearInterval(id)
  }, [])

  const minutes = Math.floor(remaining / 60)
    .toString()
    .padStart(2, '0')
  const seconds = (remaining % 60).toString().padStart(2, '0')

  return {
    minutes,
    seconds,
    formatted: `${minutes}:${seconds}`,
    isExpired: remaining <= 0
  }
}
